import { getCurrentResourceFiber } from "../../core/execution-context.js";
export const tapHook = (type, init) => {
    const fiber = getCurrentResourceFiber();
    const index = fiber.currentIndex++;
    if (!fiber.isFirstRender && index >= fiber.cells.length) {
        // Check if we're trying to use more hooks than in previous renders
        throw new Error("Rendered more hooks than during the previous render. " +
            "Hooks must be called in the exact same order in every render.");
    }
    let cell = fiber.cells[index];
    if (!cell) {
        cell = init();
        fiber.cells[index] = cell;
    }
    if (cell.type !== type) {
        throw new Error("Hook order changed between renders");
    }
    return cell;
};
export const registerRenderMountTask = (task) => {
    const fiber = getCurrentResourceFiber();
    fiber.renderContext.commitTasks.push(task);
};
//# sourceMappingURL=tapHook.js.map